/**
 * @generated SignedSource<<c4e6941758fd291b073369036a25c68d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FunnelSourceEditFormContainer_root$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "FunnelSourceEditFormContainer_root";
};
export type FunnelSourceEditFormContainer_root = FunnelSourceEditFormContainer_root$data;
export type FunnelSourceEditFormContainer_root$key = {
  readonly " $data"?: FunnelSourceEditFormContainer_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"FunnelSourceEditFormContainer_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FunnelSourceEditFormContainer_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceConnection",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SourceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Source",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "673576c69b7d719e74776351b9afd3d2";

export default node;
